import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { getIdUtenteLoggato, monFetch } from "../inc/inc";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState, useEffect } from "react";

import PopupElimina from "../elementi/PopupElimina";

const Comp = (props) => {
  const [clienti, setClienti] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [clienteDaEliminare, setClienteDaEliminare] = useState(null);

  async function query() {
    const res = await monFetch("/customerList", {});
    setClienti(res.customer);
  }

  async function eliminaCliente(id) {
    const res = await monFetch("/customerDelete", { id });
    setPopupElimina(false);
    query();
  }

  useEffect(() => {
    props.setTestoTitolo(
      <>
        <Button
          variant="contained"
          href={process.env.PUBLIC_URL + "/cliente-nuovo"}
          className="buttonSalva"
          style={{ marginRight: 20 }}
        >
          Nuovo{" "}
        </Button>
        Lista Clienti
      </>
    );
    query();
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Ragione sociale</TableCell>
            <TableCell>Indirizzo</TableCell>
            <TableCell>Città</TableCell>
            <TableCell>CAP</TableCell>
            <TableCell>Provincia</TableCell>
            <TableCell>Utente creazione</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clienti.map((cliente) => {
            return (
              <TableRow
                key={cliente.id}
                className="rigaSelezionabile"
                onClick={(e) => {
                  if (cliente.user_id == getIdUtenteLoggato()) {
                    window.location.href =
                      process.env.PUBLIC_URL + "/cliente/" + cliente.id;
                  }
                }}
              >
                <TableCell>{cliente.businessName}</TableCell>
                <TableCell>{cliente.address}</TableCell>
                <TableCell>{cliente.city}</TableCell>
                <TableCell>{cliente.zip}</TableCell>
                <TableCell>{cliente.state}</TableCell>
                <TableCell>
                  {cliente.user_firstName
                    ? cliente.user_firstName + " " + cliente.user_lastName
                    : ""}
                </TableCell>
                <TableCell>
                  {cliente.user_id == getIdUtenteLoggato() && (
                    <DeleteIcon
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPopupElimina(true);
                        setClienteDaEliminare(cliente.id);
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => eliminaCliente(clienteDaEliminare)}
      />
    </>
  );
};

export default Comp;
